import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { ROUTES } from '../../constants/routes';
import { doctorStartSubscription } from '../services/doctorApi';
import { useDoctorSession } from '../contexts/DoctorSessionContext';

export default function DoctorPaywallScreen() {
  const navigate = useNavigate();
  const { t, language } = useLanguage();
  const { refreshDoctor, showToast } = useDoctorSession();
  const [loading, setLoading] = useState(null);
  const [error, setError] = useState('');

  const subscribe = async (plan) => {
    setLoading(plan);
    setError('');
    try {
      // Tap Payments SDK stub — marks subscription active on success path
      await doctorStartSubscription(plan);
      await refreshDoctor();
      showToast(t('doctorSubscriptionStarted'));
      navigate(ROUTES.DOCTOR_PATIENTS, { replace: true });
    } catch (err) {
      setError(err.message || 'Payment failed');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-page px-4 py-6">
      <button type="button" onClick={() => navigate(-1)} className="mb-4 text-gray-600">
        <ArrowLeft className="h-5 w-5" />
      </button>
      <h1 className="text-2xl font-bold text-slate-900">
        {language === 'ar' ? 'انتهت فترة التجربة المجانية' : 'Your free trial has ended'}
      </h1>
      <p className="mt-2 text-sm text-gray-600">
        {language === 'ar'
          ? 'استخدمت جميع الـ 20 ملاحظة المجانية. اشترك لمتابعة التوثيق مع صوتنا.'
          : 'You used all 20 free notes. Subscribe to continue documenting with Sawtna.'}
      </p>

      {error && (
        <div className="mt-4 rounded-xl bg-critical-light px-4 py-3 text-sm text-critical-dark">
          {error}
        </div>
      )}

      <div className="mt-6 space-y-4">
        <div className="rounded-2xl bg-white p-5 ring-1 ring-gray-100">
          <p className="text-lg font-bold text-slate-900">15 JOD / month</p>
          <p className="text-sm text-gray-500">{t('doctorBilledMonthly')}</p>
          <button
            type="button"
            disabled={loading}
            onClick={() => subscribe('monthly')}
            className="btn-primary mt-4 disabled:opacity-60"
          >
            {loading === 'monthly' ? '…' : t('doctorSubscribeMonthly')}
          </button>
        </div>

        <div className="relative rounded-2xl bg-white p-5 ring-2 ring-primary">
          <span className="absolute -top-3 right-4 rounded-full bg-primary px-3 py-0.5 text-xs font-bold text-white">
            {t('doctorBestValue')}
          </span>
          <p className="text-lg font-bold text-slate-900">120 JOD / year</p>
          <p className="text-sm text-gray-500">{t('doctorSaveAnnual')}</p>
          <button
            type="button"
            disabled={loading}
            onClick={() => subscribe('annual')}
            className="btn-primary mt-4 disabled:opacity-60"
          >
            {loading === 'annual' ? '…' : t('doctorSubscribeAnnual')}
          </button>
        </div>
      </div>
    </div>
  );
}
